module.exports = __webpack_public_path__ + "static/media/Inter-italic.var.b14d906b.woff2";